export interface IAloLogbookItemConstParam {
  lbkId: number
  fleId?: number
  misId?: number
  gliCycle: number | null
  usrId: number | null
  usrNom: string
  usrPrenom: string
  utcDatadd: string
  message: string
  histo: string
  mailAlertJson: string
  internalJson?: { sender?: string } | null
}

export class AloLogbookItem {
  public lbkId: number
  public fleId: number
  public misId: number
  public gliCycle: number | null
  public usrId: number | null
  public usrNom: string
  public usrPrenom: string
  public utcDatadd: Date | null
  public message: string
  public histo: Array<{ date: Date | null; message: string }>
  public mailAlertJson: string
  public internalJson: { sender?: string } | null

  constructor(
    {
      lbkId = 0,
      fleId = -1,
      misId = -1,
      gliCycle = null,
      usrId = null,
      usrNom = '',
      usrPrenom = '',
      utcDatadd = '',
      message = '',
      histo = '[]',
      mailAlertJson = '',
      internalJson = null,
    }: IAloLogbookItemConstParam = {} as IAloLogbookItemConstParam,
  ) {
    this.lbkId = lbkId
    this.fleId = fleId
    this.misId = misId
    this.gliCycle = gliCycle
    this.usrId = usrId
    this.usrNom = usrNom
    this.usrPrenom = usrPrenom
    this.utcDatadd = new Date(utcDatadd)
    this.message = message
    this.histo = JSON.parse(histo ?? '[]') ?? []
    this.mailAlertJson = mailAlertJson
    this.internalJson = internalJson ?? null

    Object.freeze(this)
  }

  get sender(): string | null {
    return this.internalJson?.sender ?? null
  }

  static createAloLogbookItem(data: any) {
    return new AloLogbookItem(data)
  }
}
